import LayoutActividad from "../../../components/LayoutActividad";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { modulo12 } from "../../../routes/Module12";
import Sidebar from "../Sidebar";

import Imagen1 from "../../../images/modulo12/arco.png";
import Imagen2 from "../../../images/modulo12/escoba.png";
import GuiaDocente from "../../../components/GuiaDocente";
import Imagen3 from "../../../images/modulo12/sarten.png";
import Imagen4 from "../../../images/modulo12/taxiamarillo.png";
import Imagen5 from "../../../images/modulo12/martillo.png";
import Imagen6 from "../../../images/modulo12/flores.png";
import Modulo12U3Act2 from "../../../DnD/modulo12U3Act2";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo12/Unidad3Actividad2.mp3";

const Actividad3 = () => {
  const infoUnidad = modulo12.content[2];
  const infoAct = modulo12.content[2].activities[1];
  const crumbs = [
    {
      title: modulo12.title,
      url: "/" + modulo12.url,
    },
    {
      title:
        modulo12.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo12.content[2].name}: ${modulo12.content[2].activities[2].name}`,
    linkNext: `${modulo12.url}/${modulo12.content[2].path}/${modulo12.content[2].activities[2].path}`,
    titlePrev: `${modulo12.content[2].name}: ${modulo12.content[2].activities[0].name}`,
    linkPrev: `${modulo12.url}/${modulo12.content[2].path}/${modulo12.content[2].activities[0].path}`,
  };

  const metadata = {
    color: modulo12.color,
    title: `${modulo12.title} - ${infoAct.name}`,
    name: modulo12.title,
  };

  const items = [
    <div className="w-200 p-4 text-center bg-white">
      <img src={Imagen1} className="img-fluid img-80" alt="Peruanos" />
      <div>Arco de fútbol</div>
    </div>,
    <div className="w-200 p-4 text-center bg-white">
      <img src={Imagen2} className="img-fluid" alt="Peruanos" />
      <div>Escoba y recogedor</div>
    </div>,
    <div className="w-200 p-4 text-center bg-white">
      <img src={Imagen3} className="img-fluid" alt="Peruanos" />
      <div>Sartén</div>
    </div>,
    <div className="w-200 p-4 text-center bg-white">
      <img src={Imagen4} className="img-fluid" alt="Peruanos" />
      <div>Taxi</div>
    </div>,
    <div className="w-200 p-4 text-center bg-white">
      <img src={Imagen5} className="img-fluid" alt="Peruanos" />
      <div>Martillo</div>
    </div>,
    <div className="w-200 p-4 text-center bg-white">
      <img src={Imagen6} className="img-fluid" alt="Peruanos" />
      <div>Flores</div>
    </div>,
  ];

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo12.color} hat-text`}>
          <FontAwesomeIcon icon={faEye} /> Observamos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />

      <div className="row">
        <div className="col-12 mb-1">
          <ul className="">
            <li>Observa las imágenes.</li>
          </ul>
        </div>
      </div>

      <Modulo12U3Act2 items={items} />

      <ul>
        <li>
          ¿Cuáles imágenes se asocian comúnmente con hombres? ¿Cuáles con
          mujeres? ¿Cuáles con los dos? Arrástralas a los recuadros
          correspondientes.
        </li>
      </ul>

      <GuiaDocente>
        <ul>
          <li>
            Lea la primera indicación: Observa las imágenes. Pida a los niños y
            niñas que observen las imágenes y lean en silencio las palabras que
            aparecen debajo de ellas. Lea la siguiente indicación: ¿Cuáles
            imágenes se asocian comúnmente con hombres? ¿Cuáles con mujeres?
            ¿Cuáles con los dos? Clasifícalas en la siguiente tabla.
          </li>
          <li>
            Explique que deben colocar las palabras en alguno de los recuadros
            que aparecen en la parte inferior. Por ejemplo, si consideran que el
            arco de fútbol se asocia con ser un deporte de hombres, deberán
            arrastrar “Arco de fútbol” hacia el recuadro que dice “Hombres”.
          </li>
          <li>
            Déles un tiempo para trabajar la actividad de manera individual.
            Pregunte a niños y niñas dónde ubicaron cada objeto. Es probable que
            coloquen “Arco de fútbol”, “Taxi” y “Martillo” en la columna de
            “Hombres” y que coloquen “Escoba y recogedor”, “Sartén” y “Flores”
            en la columna de “Mujeres”. A partir de ello, explique que la
            sociedad asocia ciertos objetos al rol de las personas. Así, por
            ejemplo, el arco de fútbol se asocia a un deporte que muchas veces
            se vincula a características o habilidades que se cree que son
            únicamente masculinas. Sin embargo, desde hace muchos años las
            mujeres han demostrado que son muy hábiles en este deporte. Puede
            comentar que, a pesar de que hace décadas que existen ligas de
            fútbol femenino, es recién en 1996 que este deporte se incorpora a
            los Juegos Olímpicos.
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad3;
